<template>
  <el-dialog 
    :visible="visible"
    :before-close="handleClose"
  >
    <MarkdownDisplay :value="answer.description" />
    <FileDownloadCard v-if="answer.attachment" :href="answer.attachment" />
  </el-dialog>
</template>

<script>
import MarkdownDisplay from "@/atoms/MarkdownDisplay.vue";
import FileDownloadCard from "@/atoms/FileDownloadCard.vue";
import { getAnswerByHomeworkAndStudent } from "@/api/homeworks.js";

export default {
  name: "AnswerPreview",
  components: {
    MarkdownDisplay,
    FileDownloadCard
  },
  props: {
    visible: Boolean
  },
  data() {
    return {
      answer: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await getAnswerByHomeworkAndStudent(
        this.$route.params.homework_id,
        this.$store.state.userId
      );
      if (res.length === 1) {
        this.answer = res[0];
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style>
</style>